import clsx from 'clsx';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useTracking } from 'react-tracking';

import { TextButton } from '@components/Button/variants';
import IconCopyLink from '@components/Images/Rebranding/IconCopyLink';
import { ClickTarget, click } from '@tracking';

interface CopyLinkButtonProps {
  className?: string;
  label: string;
  linkToCopy: string;
}

const CopyLinkButton = ({ className, linkToCopy, label }: CopyLinkButtonProps) => {
  const [copied, setCopied] = useState(false);
  const { trackEvent } = useTracking();

  const handleCopy = () => {
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error('Failed to copy link: ', err);
        toast.error('Failed to copy link');
      });

    trackEvent(
      click({
        clickTarget: ClickTarget.Link,
        clickText: linkToCopy,
      })
    );
  };

  return (
    <TextButton
      as="button"
      onClick={handleCopy}
      className="group flex items-center"
      aria-label={label}
    >
      <IconCopyLink
        className={`mr-4 h-[13px] ${
          copied ? 'text-primary-magenta' : 'text-grayscale-gray group-hover:text-primary-magenta'
        }`}
      />
      <span
        className={clsx(
          'font-suisse-intl text-button-sm underline',
          copied ? 'text-primary-magenta' : 'group-hover:text-primary-magenta',
          className
        )}
      >
        {copied ? 'Copied!' : label}
      </span>
    </TextButton>
  );
};

export default CopyLinkButton;
